import React from 'react';
import CircularProgress from '../../../components/CircularProgress';

const TenderCalculationList = React.lazy(() => import('../components/TenderCalculationList'));

function TenderCalculationListView(props: any) {
  return (
    <React.Suspense fallback={<CircularProgress />}>
      <TenderCalculationList {...props} />
    </React.Suspense>
  );
}

export default TenderCalculationListView;
